/**
 * Helpers for invite acceptance flow: redirect path and detection.
 * Never log or expose token values.
 */

export const INVITE_JUST_ACCEPTED_KEY = 'dsos_invite_just_accepted';

/**
 * Build the redirect path for auth when user must sign in to accept an invite.
 * Preserves token in the return URL.
 */
export function getInviteRedirectPath(token: string | null): string {
  if (!token?.trim()) return '/accept-invite';
  return `/accept-invite?token=${encodeURIComponent(token.trim())}`;
}

/**
 * Whether the given redirect URL indicates the user is in the invite acceptance flow.
 * Used to hide trial/paywall and show invite-specific copy.
 */
export function isInviteRedirect(redirect: string | null): boolean {
  if (!redirect || typeof redirect !== 'string') return false;
  const decoded = decodeURIComponent(redirect);
  if (decoded.includes('/accept-invite')) return true;
  if (decoded.includes('token=') && (decoded.includes('invite') || decoded.includes('accept'))) return true;
  return false;
}

/*
 * Manual test checklist (invite flow):
 * 1) New user: email CTA -> /accept-invite -> /auth -> sign up (no trial modal) -> accept -> /app
 * 2) Existing user: CTA -> /accept-invite -> sign in -> accept -> /app
 * 3) Invalid token: friendly error, no crash
 * 4) Already accepted token: success, redirect
 * 5) No token: "Invalid invite link" + Sign in / Back to home
 */
